module.exports = __webpack_public_path__ + "img/10.a5ac2269.png";